import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css"; // Ensure you have a Navbar.css file for styling

const Navbar = () => {
  return (
    <nav className="navbar">
      {/* Clickable logo that navigates to home */}
      <Link to="/" className="logo">
        QuickFit
      </Link>
      <ul className="nav-links">
        <li><Link to="/brands">Brands</Link></li>
        <li><Link to="/blog">Blog</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/contact">Contact</Link></li>
      </ul>
    </nav>
  );
};

export default Navbar;
